import {fonts} from '../../../../theme/foundations/fonts'
import sizes from '../../../../theme/foundations/sizes'
import {pxToRem} from '../../../../utills/pxToRem'

export const informationAccordionStyle = {
    borderStyle: 'none',
    marginTop: pxToRem(31),
    color: 'black',
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(21)
    }
}

export const accordionHeadingStyle = {
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '500',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(14)
    }
}

export const accordionPanelStyle = {
    padding: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '400',
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(14)
    },
    p: {
        letterSpacing: pxToRem(1)
    }
}

export const iconStyle = {
    width: pxToRem(17),
    height: pxToRem(17)
}
